import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Payment } from 'src/app/core/dtos/payment';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { PaymentService } from 'src/app/services/pago/payment.service';

@Component({
  selector: 'app-lista-pagos',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './lista-pagos.component.html',
  styleUrl: './lista-pagos.component.css',
  standalone: true
})
export class ListaPagosComponent implements OnInit {
  payments: Payment[] = [];
  clienteId!: number;
  loading = true;
  error = '';
  usuarioId: number = 0; 
  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private currentUserService: CurrentUserService 
  ) {}

  ngOnInit(): void {
    // Obtener el usuarioId del localStorage
    const usuarioId = this.currentUserService.getUsuarioId();
    if (usuarioId) {
      this.usuarioId += usuarioId;
    } else {
      this.error = 'primero debes iniciar sesión.';
      this.loading = false;
      return;
    }
    this.route.queryParams.subscribe(params => {
      this.clienteId = +params['clienteId'];
      if (this.clienteId) {
        this.loadPayments();
      } else {
        this.error = 'Cliente no especificado.';
        this.loading = false;
      }
    });
  }

  loadPayments() {
    this.paymentService.getPaymentsByCliente(this.usuarioId,this.clienteId).subscribe({
      next: (res) => {
        this.payments = res;
        this.loading = false;
      },
      error: () => {
        this.error = 'Error al cargar pagos.';
        this.loading = false;
      }
    });
  }

  volverACliente(){
    this.router.navigate(['/cliente']);
  }
}
